// extracted by mini-css-extract-plugin
export default {"modalTitle":"FullScreenModal_modalTitle__j5oRG"};